import React from "react";
import { Button, Modal } from "react-bootstrap";

export function SendConfirmationDialog({ show, onHide, onConfirm }) {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Send Trial Confirmation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-danger small mb-0">
          An email confirmation will be sent to the customer. Are you sure you want to proceed?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="success" onClick={onConfirm}>
          Yes, send confirmation
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
